import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import Thumbnail from '@/components/Thumbnail.vue';
import { InfoTag } from '@/models/Menu';
import { TypeOrder } from '@/store/state';
let CardList = class CardList extends Vue {
    async goTo(data) {
        if (data.open) {
            this.$emit('getInfo');
            await this.$store.dispatch('getRestaurant', data.restaurantId);
            await this.$store.dispatch('getMenu', data.id);
            await this.$store.dispatch('getDeliveryMenu', data.id);
            await this.$store.dispatch('setTypeOrder', TypeOrder.DELIVERY);
            await this.$store.dispatch('setNewOrder');
            const menu = this.$store.state.menu;
            if (menu) {
                const localizations = menu.localizations;
                const local = localizations.find(local => local.language == 'spanish');
                if (local)
                    this.setLocalization(local);
            }
            await this.$router.push(`/menu`);
        }
    }
    setLocalization(localization) {
        this.$store.dispatch('changeCurrency', localization.currency);
        this.$store.dispatch('changeLanguage', localization.language);
        this.$emit('select');
    }
    getTagStyle(infoTag) {
        switch (infoTag) {
            case InfoTag.FREESHIPPING:
                return `border: 1px solid #e51f2f; color: #e51f2f;`;
            case InfoTag.PROX:
                return `border: 1px solid #000000; color: #000000;`;
            case InfoTag.CLOSE:
                return `border: 1px solid #000000; color: #000000;`;
            case InfoTag.DISCOUNT30:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            case InfoTag.DISCOUNT15:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            case InfoTag.DISCOUNT20:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            case InfoTag.DISCOUNT40:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            case InfoTag.DISCOUNT50:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            case InfoTag.PROMOCOMBO:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            case InfoTag.SHIPPING1:
                return `border: 1px solid #EF7F1A; color: #EF7F1A;`;
            default:
                return;
        }
    }
    getOpenAt(openAt) {
        const aux = new Date(openAt);
        const hour = aux.getHours();
        const minutes = aux.getMinutes();
        return 'Abre: ' + ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2);
    }
};
__decorate([
    Prop({ default: null })
], CardList.prototype, "restaurant", void 0);
CardList = __decorate([
    Component({
        components: {
            Thumbnail,
        }
    })
], CardList);
export default CardList;
